import { Component, Input } from '@angular/core';

/** 스타일이 중복되서 event style 사용 */
@Component({
  selector: '[appointment-payment]',
  templateUrl: './appointment-payment.component.html',
  styleUrls: ['./appointment-event.component.scss'],
})

export class AppointmentPayment {

  private static TAIL_YEAR: string = '년';
  private static TAIL_MONTH: string = '월';
  private static TAIL_DAY: string = '일';
  private static WEEKS: string[] = [
    '일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일',
  ];

  /**
   * 결제 예정 일
   */
  date: string = '';

  constructor() {}

  @Input('date') set paymentDate(d: Date) {
    if (d) {
      const year = d.getFullYear() + AppointmentPayment.TAIL_YEAR;
      const month = d.getMonth() + 1 + AppointmentPayment.TAIL_MONTH;
      const date = d.getDate() + AppointmentPayment.TAIL_DAY;
      const day = AppointmentPayment.WEEKS[d.getDay()];

      this.date = `${year} ${month} ${date} ${day}`;
    }
  }
}
